import React from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components/macro';
import { ReactComponent as ErrorIcon } from '../../images/icons/error-circle-outline.svg';
import { colourRed06 } from '../../styling/colours';

type Props = {
  fieldName: string;
  showError: boolean;
  error: string | null;
  className?: string;
  tooltipId?: string;
};

export const FieldErrorIndicator = ({ fieldName, showError, error, className, tooltipId }: Props) => (
  <>
    <ErrorIndicatorContainer $visible={showError} className={className}>
      <ErrorIcon
        data-tip={error}
        data-for={tooltipId}
        data-testid={
          showError ? fieldErrorIndicatorInvalidTestId(fieldName) : fieldErrorIndicatorValidTestId(fieldName)
        }
      />
    </ErrorIndicatorContainer>
    {showError && <ReactTooltip id={tooltipId} effect="solid" clickable={true} />}
  </>
);

export const fieldErrorIndicatorValidTestId = (fieldName: string) => `field-error-indicator-valid-${fieldName}`;
export const fieldErrorIndicatorInvalidTestId = (fieldName: string) => `field-error-indicator-invalid-${fieldName}`;

const ErrorIndicatorContainer = styled.div<{ $visible: boolean }>`
  cursor: ${props => (props.$visible ? 'pointer' : 'default')};
  opacity: ${props => (props.$visible ? 1 : 0)};
  transition: all 0.25s ease;
  height: 20px;
  width: 20px;
  min-height: 20px;
  min-width: 20px;
  color: ${colourRed06};

  svg {
    height: 20px;
    width: 20px;
    min-height: 20px;
    min-width: 20px;
  }
`;
